import {HttpClient} from '@angular/common/http';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import { Observable, of } from 'rxjs';
import {Injectable} from '@angular/core';

@Injectable()
export class Security{
  constructor(public http: HttpClient, public router: Router) {}

  public checkIfAllowed(code: string): Observable<boolean>{
    return this.checkLogin(code);
  }
  // Rückgabewert der PHP-Datei als Observable<boolean>
  public checkLogin(code: string): Observable<boolean> {
    return  this.http.get
    (
      window.location.protocol + '//' + window.location.hostname + `/myDay/backend/checkGrant.php?email=${localStorage.getItem('userEmail')}&code=${code}`
    ) as Observable<boolean>;
  }

}
